import { render, staticRenderFns } from "./StripePricingTable.vue?vue&type=template&id=2fd97076&"
import script from "./StripePricingTable.vue?vue&type=script&lang=js&"
export * from "./StripePricingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports